import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    favouritesBackLink: '',
    favouriteIds: []
  },

  mutations: {
    ADD_TO_FAVOURITES (state, id) {
      state.favouriteIds.push(id)
    },

    REMOVE_FROM_FAVOURITES (state, id) {
      var favouriteIds = _.remove(state.favouriteIds, function(favouriteId) {
        return favouriteId !== id
      })

      state.favouriteIds = favouriteIds
    },

    SET_FAVOURITES (state, ids) {
      state.favouriteIds = ids
    },

    SET_FAVOURITES_BACK_LINK (state, url) {
      state.favouritesBackLink = url
    }
  },

  getters: {
    favourites: (state, getters, rootState, rootGetters) => {
      const _packages = rootGetters['property/livingOptionsPackages']
      const properties = rootGetters['property/properties']
      const dwellings = rootGetters['property/dwellings']

      if (state.favouriteIds.length) {
        const allProducts = [...properties, ..._packages, ...dwellings]
        const favouriteIds = state.favouriteIds
        let favourites = []

        allProducts.forEach(product => {
          if (favouriteIds.includes(product._id)) {
            favourites.push(product)
          }
        })
        
        return favourites
      } else {
        return []
      }
    },

    qrcode: (state) => {
      if (state.favouriteIds.length) {
        return `${process.env.VUE_APP_FAVOURITES_HOST}?r=0&p=${state.favouriteIds.toString()}`
      } else {
        return false
      }
    },

    viewFavouritesLink: (state, getters, rootState, rootGetters) => {
      if (state.favouriteIds.length) {
        return `/${rootGetters.activeCategory}/favourites?p=${state.favouriteIds.toString()}`
      } else {
        return ''
      }
    }
  }
}
